import React from 'react';

const CustomButton = ({ 
  children, 
  onClick, 
  variant = 'primary', 
  disabled = false,
  ...props 
}) => {
  const baseStyles = {
    padding: '0px 24px',
    border: 'none',
    borderRadius: '4px',
    cursor: disabled ? 'not-allowed' : 'pointer',
    fontWeight: '400',
    fontSize: '14px',
    transition: 'all 0.2s ease',
    opacity: disabled ? 0.6 : 1,
    height: '38px',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap'
  };

  const variantStyles = {
    primary: {
      backgroundColor: 'var(--BaseDarkColor)',
      color: '#ffffff',
    },
    outline: {
      backgroundColor: 'transparent',
      color: 'var(--BaseDarkColor)',
      border: '1px solid var(--BaseDarkColor)',
    },
  };

  return (
    <button
      style={{...baseStyles, ...variantStyles[variant]}}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default CustomButton;